import { ThemeSystemConfig } from '../clipCreator/remotion/Components/Theme/Theme';

export const DEFAULT_THEME_CONFIG: ThemeSystemConfig = {
    brandConfig: {
        primaryColor: '#000000',
        secondaryColor: '#FFFFFF',
        accentColor: '#FFFFFF',
        titleFont: 'inter',
        bodyFont: 'inter',
        logoURL: '',
        titleFontOutline: 'none',
        bodyFontOutline: 'none',
        borderRadius: 0
    },
    backgroundConfig: {
        imageURL: '',
        color: '#000000',
        format: 'color'
    },
    frameConfig: {
        borderRadius: 0,
        padding: false,
        border: false,
        borderStyle: 'no_border'
    },
    savedCaptionConfig: {
        id: 'default',
        name: 'Default',
        type: 'trebble',
        captionConfig: {
            milisecondGrouping: 1000,
            font: 'inter',
            useDesignSystemColor: true,
            mainColor: '#FFFFFF',
            highlightColor: '#FFFFFF',
            outline: 'none',
            fontSizeRatio: 'medium',
            background: 'none',
            textAnimation: 'none',
            borderRadius: 0,
            captionCase: 'standard',
            hidePunctuation: false,
            showOneWordOnly: false,
            maxLines: 'two_lines',
            position: 'bottom center'
        }
    }
};
